"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Impact() {
  const container = useRef<HTMLDivElement>(null);
  const stats = [{
    value: 85,
    suffix: "%",
    caption: "Members reporting positive life changes"
  }, {
    value: 4.2,
    suffix: "\u00D7",
    caption: "Growth in community outreach reach this quarter",
    decimals: 1
  }, {
    value: 12,
    suffix: "%",
    caption: "Annual increase in local support"
  }, {
    value: 500,
    suffix: "+",
    caption: "Active members in our foundation"
  }];
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      reduced: "(prefers-reduced-motion: reduce)",
      full: "(prefers-reduced-motion: no-preference)"
    }, ctx => {
      const {
        reduced
      } = ctx.conditions as {
        reduced: boolean;
        full: boolean;
      };
      const numberEls = gsap.utils.toArray<HTMLElement>(".stat-number");
      const captionEls = gsap.utils.toArray<HTMLElement>(".stat-caption");
      const dividerEls = gsap.utils.toArray<HTMLElement>(".stat-divider");
      if (reduced) {
        numberEls.forEach(el => {
          const target = Number(el.dataset.value || "0");
          const decimals = Number(el.dataset.decimals || "0");
          el.textContent = target.toFixed(decimals);
        });
        return;
      }
      numberEls.forEach(el => {
        const target = Number(el.dataset.value || "0");
        const decimals = Number(el.dataset.decimals || "0");
        const obj = {
          val: 0
        };
        gsap.to(obj, {
          val: target,
          duration: 0.9,
          ease: "power2.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            once: true
          },
          onUpdate: () => {
            el.textContent = obj.val.toFixed(decimals);
          }
        });
      });
      gsap.from(captionEls, {
        opacity: 0,
        y: 12,
        duration: 0.6,
        ease: "power2.out",
        delay: 0.12,
        stagger: 0.08,
        scrollTrigger: {
          trigger: container.current,
          start: "top 85%",
          once: true
        }
      });
      gsap.from(dividerEls, {
        scaleX: 0,
        transformOrigin: "left center",
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: container.current,
          start: "top 85%",
          once: true
        }
      });
    });
  }, {
    scope: container
  });
  return;
}